/**
 * Simple utility function to format map values into an array.
 * */
const MapFormatter = source => {
    // Returns an empty array if no valid source is provided
    if (
        !source ||
        !(source instanceof Map)
    ) {
        return [];
    }

    // The array of values to be soon returned
    let formattedValues = [];

    // Appends all values to the array above
    for (let value of source.values()) {
        formattedValues.push(value);
    }

    return formattedValues;
}

export default MapFormatter;
